/**
 * Countries that use miles as their primary distance unit
 */
const MILES_COUNTRIES = ['US'];

/**
 * Check if the given country code uses miles as the distance unit
 * @param {string} countryCode - The country code to check
 * @returns {boolean} - True if the country uses miles, false otherwise
 */
export function isLocationInMiles(countryCode) {
  return MILES_COUNTRIES.includes(countryCode);
}

/**
 * Helper function to get translated miles or kilometers based on country code
 * @param {string} countryCode - The country code to check
 * @param {Object} intl - The intl service for translations
 * @returns {string} - Translated "miles" or "kilometers"
 */
export function distanceUnit(countryCode, intl) {
  const isMiles = isLocationInMiles(countryCode);
  const translationKey = isMiles ? 'global.miles' : 'global.kilometers';
  return intl.t(translationKey);
}
